import React from 'react';
import { Box } from 'rebass/styled-components';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import SideModal from 'components/atoms/sideModal';
import { AutoUpdate } from './autoUpdate';
import { useCreateList } from './hooks/useCreateList';
import { UpdateListSkeleton } from './components/updateListSkeleton';
import Initial from './steps/initial';
import CompaniesCreate from './steps/companiesCreate';
import ContactsCreate from './steps/contactsCreate';
import { useRerunAutoUpdate } from './hooks/useRerunAutoUpdate';
export const CreateList = ({ goBack: close }) => {
  const {
    step,
    setStep,
    formRef,
    formSchema,
    isEdit,
    isSubmitting,
    goBack,
    title,
    onAutoUpdateSelected,
    onSubmit,
    activeNetwork,
    filters,
    setFilters,
    formDefaultValues,
    contactsCount,
    isUpdatingList,
    isLoadingList,
    updateSmartOption,
    isError,
    hasAutoUpdateFilters,
    sharedList,
  } = useCreateList();
  const { onClickAutoUpdate, isLoadingRefresh, lastUpdated } = useRerunAutoUpdate(sharedList);

  const history = useHistory();
  return (
    <SideModal
      isLoading={isLoadingList}
      loadingComponent={UpdateListSkeleton}
      headerText={title}
      goBack={goBack}
      width="680px"
      onClose={() => {
        if (close) {
          close();
          return;
        }

        if (isEdit) {
          history.goBack();
          return;
        }
        history.push('.');
      }}
    >
      <Box>
        {step === 'initial' && <Initial setStep={setStep} networkIsEcosystem={activeNetwork?.kind === 'ecosystem'} />}
        {step === 'contacts:create' && (
          <ContactsCreate
            formRef={formRef}
            formDefaultValues={formDefaultValues}
            formSchema={formSchema}
            isEdit={isEdit}
            isUpdatingList={isUpdatingList}
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
            updateSmartOption={updateSmartOption}
            contactsCount={contactsCount}
            hasAutoUpdateFilters={hasAutoUpdateFilters}
            setStep={setStep}
            isLoadingRefresh={isLoadingRefresh}
            lastUpdated={lastUpdated}
            onClickAutoUpdate={onClickAutoUpdate}
            isDynamicTalentPool={sharedList?.isDynamicTalentPool}
          />
        )}
        {step === 'contacts:autoUpdate' && (
          <AutoUpdate
            onAutoUpdateSelected={onAutoUpdateSelected}
            isTalentNetworkEnabled={!activeNetwork?.tnHidden}
            setFilters={setFilters}
            filters={filters}
            isUpdatingList={isUpdatingList}
            isEdit={isEdit}
            showTalentNetworkFilters={activeNetwork?.features?.includes('job_board')}
          />
        )}
        {step === 'companies:create' && (
          <CompaniesCreate
            formDefaultValues={formDefaultValues}
            isEdit={isEdit}
            isUpdatingList={isUpdatingList}
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
            isError={isError}
          />
        )}
      </Box>
    </SideModal>
  );
};

CreateList.propTypes = {
  goBack: PropTypes.func,
};
CreateList.defaultProps = {
  goBack: null,
};
